import React from 'react';

import { CircularProgress } from '@mui/material';

import styles from './Spinner.module.scss';

interface SpinnerProps {
  size?: number;
}

const Spinner = ({ size = 95 }: SpinnerProps) => {
  return (
    <div className={styles.spinnerContainer}>
      <CircularProgress variant="determinate" thickness={4} size={size} value={100} className={styles.spinnerBase} />
      <CircularProgress variant="indeterminate" thickness={4} size={size} className={styles.spinnerCircle} />
    </div>
  );
};

export default Spinner;
